export default {
  list: {
    colName: "Nombre",
    colContact: "Contacto",
    colBalance: "Saldo",
    colActions: "Acciones",
    statusActive: "Activo",
    statusInactive: "Inactivo",
    retry: "Reintentar",
    emptySearch: "Ningún resultado coincide con la búsqueda.",
    filterRole: "Rol",
    filterRoleAll: "Todos",
    filterRoleSeller: "Vendedores",
    filterRoleHost: "Anfitriones",
    filterRoleSalesAgent: "Agentes de ventas",
    filterRoleAdmin: "Staff",
    statusTooltipActive: "Cuenta activa",
    statusTooltipInactive: "Cuenta inactiva",
    filterStatus: "Estado",
    filterAll: "Todos",
    filterActive: "Activos",
    filterInactive: "Inactivos",
    openRowAria: "Abrir usuario {{name}}",
    relevantSeller_one: "{{count}} actividad",
    relevantSeller_other: "{{count}} actividades",
    relevantHost_one: "{{count}} estructura",
    relevantHost_other: "{{count}} estructuras",
    relevantSalesAgent_one: "{{count}} asociación",
    relevantSalesAgent_other: "{{count}} asociaciones",
  },
  detail: {
    backToUsers: "Volver a usuarios",
    activate: "Activar",
    deactivate: "Desactivar",
    statWallet: "Saldo de cartera",
    statRevenue: "Ingresos totales",
    contactCard: "Información de contacto",
    email: "Correo de la cuenta",
    phone: "Teléfono",
    contactEmail: "Correo de contacto",
    vatNumber: "NIF-IVA",
    billingAddress: "Dirección de facturación",
    legalInfoCard: "Perfil legal",
    editLegalInfo: "Editar perfil",
    cancelEditLegalInfo: "Cancelar edición",
    loadLegalInfo: "Cargando perfil legal...",
    loadLegalInfoError: "No se pudo cargar el perfil legal",
    sendPasswordReset: "Enviar correo de restablecimiento",
    toastPasswordResetSent: "Correo de restablecimiento enviado.",
    lastLogin: "Último acceso",
    lastLoginNever: "Nunca ha iniciado sesión",
    passwordResetActiveLink:
      "Un enlace de configuración sigue siendo válido hasta {when}. Espera a que caduque antes de enviar otro.",
    passwordResetCooldown:
      "Se envió un correo de restablecimiento recientemente. Podrás enviar otro después de {when}.",
    transactionsTitle: "Movimientos de cartera",
    tabs: {
      ariaLabel: "Secciones del perfil de usuario",
      overview: "Resumen",
      activities: "Actividades",
      activitiesDesc: "Experiencias propias",
      structures: "Estructuras",
      structuresDesc: "Casas y dispositivos",
      associations: "Asociaciones",
      associationsDesc: "Ámbito de actividades y estructuras",
      legal: "Legal",
      legalDesc: "Facturación, identidad y pago",
      transactions: "Movimientos",
    },
    statusActive: "Activo",
    statusInactive: "Inactivo",
    editDisplayName: "Editar nombre visible",
    displayNamePlaceholder: "Nombre visible",
    displayNameEmpty: "El nombre visible no puede estar vacío",
    toastDisplayNameUpdated: "Nombre visible actualizado",
    toastDisplayNameError: "No se pudo actualizar el nombre visible",
    addActivity: "Añadir actividad",
    addHouse: "Añadir estructura",
    searchActivitiesPlaceholder: "Buscar actividades…",
    noActivitiesMatchTitle: "Ninguna actividad coincide",
    noActivitiesMatchDesc: "Prueba otra búsqueda o filtro de estado.",
    active: "Activa",
    inactive: "Inactiva",
    houseRowCommission: "{{percent}}% de comisión",
    moreActions: "Más acciones",
    shortcutsTitle: "Ir a",
  },
  createModal: {
    nameLabel: "Nombre",
    emailLabel: "Correo",
    phoneLabel: "Teléfono de contacto",
    phonePlaceholder: "+34…",
    phoneRequired: "Introduce un teléfono de contacto",
    regionLabel: "Región de pago *",
    chooseRegion: "Seleccionar región…",
    regionRequired: "Selecciona una región de pago",
    inviteEmailHint:
      "Enviaremos un correo de invitación para que puedan establecer su contraseña.",
  },
  roles: {
    seller: "Vendedor",
    host: "Anfitrión",
    "sales-agent": "Agente de ventas",
    admin: "Staff",
  },
  unified: {
    title: "Usuarios",
    subtitle:
      "Vendedores, anfitriones, agentes de ventas y staff en un solo lugar",
    addButton: "Añadir usuario",
    searchPlaceholder: "Buscar por nombre, correo o ID...",
    loadError: "No se pudieron cargar los usuarios",
    empty: "Aún no hay usuarios",
    colCount: "Cantidad",
  },
  impersonate: "Suplantar",
  rolePicker: {
    title: "¿Qué tipo de usuario quieres añadir?",
    seller: "Vendedor",
    host: "Anfitrión",
    salesAgent: "Agente de ventas",
    staff: "Staff",
    sellerDesc: "Socio que ofrece atracciones, servicios o restaurantes",
    hostDesc: "Propietario de las estructuras donde se instalan los kioscos",
    salesAgentDesc: "Gana comisiones en actividades y estructuras asignadas",
    staffDesc: "Miembro del equipo interno con permisos configurables",
  },
  createStaffModal: {
    title: "Añadir usuario staff",
    namePlaceholder: "Nombre del miembro del staff",
    emailPlaceholder: "staff@ejemplo.com",
    presetLabel: "Preset de staff *",
    choosePreset: "Seleccionar un preset…",
    presetRequired: "Selecciona un preset de staff",
    create: "Enviar invitación",
    createSuccess: "Usuario staff creado — se envió el correo de invitación",
    createError: "No se pudo crear el usuario staff",
  },
  staffAccess: {
    title: "Permisos de {{name}}",
    subtitle:
      "Asigna un preset para seguir sus permisos en vivo, o Personalizado para un conjunto individual.",
    loading: "Cargando permisos…",
    loadError: "No se pudieron cargar los permisos del staff",
    userNameFallback: "Usuario de staff",
    preset: "Preset de staff",
    presetHint:
      "Los usuarios ligados a un preset reciben automáticamente los cambios de la definición. Editar permisos pasa a Personalizado.",
    presetCustom: "Personalizado",
    enabledSummary: "{{count}} de {{total}} activos",
    permissionsHintPresetBound:
      "Permisos en vivo del preset. Cambiar cualquiera desvincula a Personalizado.",
    requiresPermissions: "Activa primero estos permisos:",
    searchPermissions: "Buscar permisos o ámbitos…",
    searchEmpty: "Ningún permiso coincide con la búsqueda",
    cannotEditSelfTitle: "Tus propios permisos",
    cannotEditSelf:
      "No puedes cambiar tu propio acceso de staff. Pide a otro Super Admin que lo actualice.",
    immutableSuperTitle: "Super Admin",
    immutableSuper:
      "El acceso Super Admin no se puede cambiar aquí — promover o degradar solo vía scripts ops (`set_super_admin.py`).",
    saveSuccess: "Permisos del staff actualizados",
    saveError: "No se pudieron actualizar los permisos del staff",
    presets: {
      super_admin: "Super Admin",
      device_tech: "Técnico de dispositivos",
      data_entry: "Entrada de datos",
      accounting: "Contabilidad",
      user_management: "Gestión de usuarios",
    },
    scopes: {
      stats: "Saldo de plataforma",
      users: "Usuarios",
      activities: "Actividades",
      houses: "Estructuras",
      storage: "Almacenamiento",
      devices: "Dispositivos",
      readers: "Lectores",
      bookings: "Reservas",
      handshakes: "Handshakes",
      customer_support: "Soporte al cliente",
      partner_support: "Soporte a partners",
      payments: "Pagos",
      alerts: "Alertas",
      protocols: "Protocolos",
      carousel: "Carrusel",
      agent_transcripts: "Transcripciones de voz",
    },
  },
} as const;
